module.exports = __webpack_public_path__ + "img/space_sticker.55f43bf5.png";